import styled, { css } from 'styled-components';

export const StatusContainer = styled.div`
  width: 100%;
  min-height: 80vh;
  display : -webkit-flex;
  display : flex;
  -webkit-flex : 2 2; 
  flex: 2 2; 
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .blank {
    flex: 1;
  }

  .statusDetailBox {
    background-color: ${props => props.theme.mainInfoModuleDetailBoxBg};
    border-radius: 20px;
    flex: 8;
    width: 420px;
    min-height: 500px;
    max-height: 500px;
    padding: 20px 0px 20px 25px;
    margin: 20px;
    display: flex;

    .statusModuleList {
      width: 100%;
      min-height: 410px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: flex-start;
      flex-wrap: wrap;
    }
  }
`;

export const StatusHeaderStyle = styled.div`
  position: relative;
  min-width: 330px;

  div {
    position: absolute;
    top: 45%;
    min-width: 370px;
    font-size: 35px;
    text-align: center;

    ${props =>
      props.status === 'danger' ? css`color: #ff0018;` :
        (props.status === 'warning' ? css`color: #e8b23a;` : 
          (props.status === 'none' ? css`color: #e0e0e0;` : css`color: #50bb5b;`))
    }
  }

  div.titleInitial {
    position: absolute;
    left: 24px;
    top: 30px;
    min-width: 76px;
    height: 76px;
    line-height: 1.1;
    font-size: 65px;
    font-weight: 500;

    ${props =>
      props.status === 'danger' ? css`color: #ff0018;` :
        (props.status === 'warning' ? css`color: #e8b23a;` : 
          (props.status === 'none' ? css`color: #e0e0e0;` : css`color: #50bb5b;`))
    }
  }

  div.warningCount {
    position: absolute;
    left: 220px;
    top: 226px;
    min-width: 76px;
    height: 76px;
    line-height: 1.1;
    font-size: 35px;

    ${props =>
      props.status === 'danger' ? css`color: #ff0018;` :
        (props.status === 'warning' ? css`color: #e8b23a;` : 
          (props.status === 'none' ? css`color: #e0e0e0;` : css`color: #50bb5b;`))
    }
  }

  img {
    min-width: 370px;
    
    ${props =>
      props.status === 'danger' ? css`content:${props => props.theme.mainInfoIconDanger};` :
        (props.status === 'warning' ? css`content:${props => props.theme.mainInfoIconWarning};` : 
          (props.status === 'none' ? css`content:${props => props.theme.mainInfoIconNone};` : 
                                    css`content:${props => props.theme.mainInfoIconBlue};`))
    }
  }
`;

export const ModuleListContainer = styled.div`
  width: 100%;
  min-height: 410px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
  flex-wrap: wrap;

  ${props =>
    props.modulesCount > 4 ? css`overflow-y: scroll;` : css`display: block;`
  }
`